module.exports = __webpack_public_path__ + "img/finalLSmv.484d7560.webp";